/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    LookupKeyEnum,
    LookupKeyEnumFromJSON,
    LookupKeyEnumFromJSONTyped,
    LookupKeyEnumToJSON,
} from './LookupKeyEnum';
import {
    MagicLinkIntentEnum,
    MagicLinkIntentEnumFromJSON,
    MagicLinkIntentEnumFromJSONTyped,
    MagicLinkIntentEnumToJSON,
} from './MagicLinkIntentEnum';

/**
 * 
 * @export
 * @interface MagicLinkRequestDto
 */
export interface MagicLinkRequestDto {
    /**
     * 
     * @type {MagicLinkIntentEnum}
     * @memberof MagicLinkRequestDto
     */
    intent: MagicLinkIntentEnum | null;
    /**
     * 
     * @type {LookupKeyEnum}
     * @memberof MagicLinkRequestDto
     */
    checkoutLookupKey?: LookupKeyEnum | null;
    /**
     * 
     * @type {boolean}
     * @memberof MagicLinkRequestDto
     */
    agreedTerms?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MagicLinkRequestDto
     */
    agreedMarketing?: boolean;
    /**
     * 
     * @type {string}
     * @memberof MagicLinkRequestDto
     */
    email: string;
}

export function MagicLinkRequestDtoFromJSON(json: any): MagicLinkRequestDto {
    return MagicLinkRequestDtoFromJSONTyped(json, false);
}

export function MagicLinkRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): MagicLinkRequestDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'intent': MagicLinkIntentEnumFromJSON(json['intent']),
        'checkoutLookupKey': !exists(json, 'checkoutLookupKey') ? undefined : LookupKeyEnumFromJSON(json['checkoutLookupKey']),
        'agreedTerms': !exists(json, 'agreedTerms') ? undefined : json['agreedTerms'],
        'agreedMarketing': !exists(json, 'agreedMarketing') ? undefined : json['agreedMarketing'],
        'email': json['email'],
    };
}

export function MagicLinkRequestDtoToJSON(value?: MagicLinkRequestDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'intent': MagicLinkIntentEnumToJSON(value.intent),
        'checkoutLookupKey': LookupKeyEnumToJSON(value.checkoutLookupKey),
        'agreedTerms': value.agreedTerms,
        'agreedMarketing': value.agreedMarketing,
        'email': value.email,
    };
}

